<template>
    <div class="app-container">
      <!--form 组件-->
      <eForm ref="form" :is-add="isAdd" :sup-this="supThis" />
      <el-card class="box-card">
        <!-- 搜索-->
        <dynamic-search
          :data="tableFilterList(tableHead)"
          @search="dataTableSearch">
          <template v-slot:next>
                <el-button icon="el-icon-plus" @click="add()">新增</el-button>
            </template>
        </dynamic-search>
        <!--表格渲染-->
        <edit-data-table
          :head="tableHead"
          :data.sync="list"
          :config="{trigger: 'click', mode: 'cell'}"
          :loading="loading"
          :defaultExpandAll="true"
          :tree-props="treeProps"
          >
            <template #toolbar="scope">
              <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
              <el-popover :ref="scope.row.id" placement="top" width="180">
                  <p>确定删除本条数据吗？</p>
                  <div style="text-align: right; margin: 0">
                      <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
                      <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
                  </div>
                  <el-button type="text" size="mini" icon="el-icon-delete" slot="reference" class="table-del-btn"></el-button>
              </el-popover>
            </template>
            <template #type="{row}">
                <el-tag v-if="row.type === 0">目录</el-tag>
                <el-tag v-if="row.type === 1">菜单</el-tag>
                <el-tag v-else-if="row.type === 2" type="warning">权限</el-tag>
            </template>
            <template #icon="row">
                <svg-icon :icon-class="row.icon" />
            </template>
            <template #enabled="{row}">
                <el-tag :type="row.enabled ? '' : 'info'">{{ row.enabled ? '启用' : '禁用'}}</el-tag>
            </template>
          </edit-data-table>
        </el-card>
    </div>
</template>

<script>
    import "@/components/EditDataTable"
    import DynamicSearch from '@/components/DynamicSearch'
    import DataTableMixin from '@/mixins/DataTableMixin'
    import initDict from '@/mixin/initDict'
    import { del } from '@/api/menu'
    import eForm from './form'
    import { deepClone } from '@/utils/index'
    export default {
        name: "Menu",
        mixins: [DataTableMixin, initDict],
        components: {
            DynamicSearch,
            eForm
        },
        data() {
            return {
                delLoading: false,
                supThis: this,
                isAdd: false,
                treeProps: {
                    children: 'children',
                    label: 'name'
                },
                tableHead: [
                    {
                        label: '菜单名称',
                        prop: 'name',
                        query: {
                            type: 'input'
                        },
                        align: 'left'
                    },{
                        label: '图标',
                        prop: 'icon'
                    },{
                        label: '链接地址',
                        prop: 'path',
                    },{
                        label: '是否启用',
                        prop: 'enabled',
                        editRender: {type: 'default'},
                        width: '100',
                    },{
                        label: '排序号',
                        prop: 'sorting',
                        width: 100,
                        sortable: true,
                    },
                    {
                        label: '创建时间',
                        prop: 'creatTime',
                        sortable: true,
                        slot: 'time'
                    }
                ]
            }
        },
        created() {
            this.$nextTick(() => {
                this.dataTableInit()
                // 加载数据字典
                this.getDict('ENABLE_STATUS')
            })
        },
        methods: {
            dataTableBeforeInit() {
                this._url = '/menu'
                const params = { current: this.page, size: this.offset }
                this._params = Object.assign(params,this._query)
                return true
            },
            subDelete(id) {
              this.delLoading = true
              del(id).then(res => {
                  this.delLoading = false
                  this.$refs[id].doClose()
                  this.dleTableChangePage()
                  this.dataTableInit()
                  this.$notify({
                      title: '删除成功',
                      type: 'success',
                      duration: 2500
                  })
              }).catch(err => {
                  this.delLoading = false
                  this.$refs[id].doClose()
                  console.log(err)
              })
            },
            add() {
              this.isAdd = true
              const _this = this.$refs.form
              _this.form = {enabled: true, type: 1}
              _this.dialog = true
            },
            edit(data) {
                this.isAdd = false
                const _this = this.$refs.form
                _this.form = deepClone(data)
                _this.dialog = true
            }
        }
    }
</script>

<style scoped lang="scss">
</style>
